<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="my-2">
                <div class="row">
                  <b-form-group class="col-md-2 px-1" label="Class">
                    <v-select :options="schoolclasses" placeholder="Select Class" v-model="schoolclass" label="name"></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2 px-1" label="Year">
                    <v-select :options="years" placeholder="Select Year" v-model="year"></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2 px-1" label="Term">
                    <v-select :options="schoolterms" placeholder="Select Term" @input="FilterExams" v-model="schoolterm" label="name"></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-3 px-1" label="Exam">
                    <v-select :options="exams" placeholder="Select Exam" v-model="exam" label="name"></v-select>
                  </b-form-group>
                  <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                  <b-button variant="primary" @click="FilterData()"><i class="mdi mdi-account-search"></i> Filter</b-button>
                </div>
                <div class="col-md-1 mt-md-4 mt-2 p-lg-0"><export-excel class="btn btn-info" :data=exammarks name="StudentsReport.xls"> Export <i class="mdi mdi-download"></i></export-excel></div>
              </div>
              </div>
              <div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="text-center"><span class="text-center h4">{{ schoolclass.name }} {{ schoolsubject.name }} {{ exam.name }}, {{ schoolterm.name }} {{ year }}</span></div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Selected Yet</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(student_photo)="data">
                  <img :src="getFiles(data.item.students.student_photo)" height="50"/>
                </template>
                <template #cell(student_id)="data">
                  <b class="text-danger">{{ data.item.students.student_id }}</b> <br>
                  {{ data.item.students.first_name }} {{ data.item.students.last_name }}
                </template>
                <template #cell(mark)="data">
                  <table class="table table-sm">
                  <tbody>
                  <tr v-for="x in data.item.exammarks" :key="x.id">
                    <td>{{ x.subjects[0].name }}</td>
                    <td>{{ x.mark[0].mark }}</td>
                    <td>{{ x.mark[0].aggregates }}</td>
                  </tr>
                  </tbody>
                </table>
                </template>
                <template #cell(division)="data">
                  <span v-if="data.item.aggregates<='12'">DI</span>
                  <span v-else-if="data.item.aggregates<='23'">DII</span>
                  <span v-else-if="data.item.aggregates<='29'">DIII</span>
                  <span v-else-if="data.item.aggregates<='34'">DV</span>
                  <span v-else>U</span>
                </template>
                </b-table>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
//   import Multiselect from "vue-multiselect";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { schooltermMethods, schooltermComputed , schoolclassMethods, schoolclassComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Students Report",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader,
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Students Report",
        items: [ {text: "Dashboard",to: "/",}, {text: "Students Report",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'student_photo', label: 'Photo', visible: true },
            { key: 'student_id', label: 'Student ID', visible: true },
            { key: 'mark', label: 'Marks', visible: true },
            { key: 'total', label: 'Total', visible: true },
            { key: 'aggregates', label: 'Aggregates', visible: true },
            { key: 'division', label: 'Division', visible: true },
          ],
        id:'',
        schoolsubjects:[], schoolsubject:'', schoolterm:'', schoolclass:'', exam:'', exams:[],
        year:new Date().getFullYear(),
        exammarks:[],
      };
    },
    computed: {
      ...schooltermComputed,
      ...schoolclassComputed,
      List() { return this.exammarks.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.exammarks.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.exammarks.length>0) { a=false;} else { a=true;} return a },
      years() {
        const currentYear = new Date().getFullYear();
        const startYear = currentYear - 10;
        const endYear = currentYear;
        const yearArray = [];
        for (let year = startYear; year <= endYear; year++) {  yearArray.push(year);  }
        return yearArray;
      },
    },
    mounted() {
      this.fetchSchoolTerms();
      this.fetchSchoolClasses();
      this.TotalRows = this.exammarks.length;
      this.isBusy=false;
      this.schoolterm = this.schoolterms.find(option => option.active == 1);
    },
    methods: {
        ...schooltermMethods,
        ...schoolclassMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      async FilterExams(){
        let url = `/findschoolexam/${this.schoolterm.id},${this.year},${this.schoolclass.id}`;
          await axios.get(url).then((response) => {
              this.exams = response.data.exams;
          });
      },
      getFiles(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"students/"+name;
        return imagelink;
      },
      FilterData() { 
        let formData = new FormData();
        formData.append("schoolterm", this.schoolterm.id);
        formData.append("year", this.year);
        formData.append("schoolclass", this.schoolclass.id);
        formData.append("exam", this.exam.id);
        let url = "/viewexammarks";
        axios.post(url, formData).then((response) => {
            this.exammarks = response.data.marks;
        })
      },
      async changeMark(mark,id) { 
        let formData = new FormData();
        formData.append("id", id);
        formData.append("mark", mark);
        let url = "/updateexammarks";
        await axios.post(url, formData).then((response) => { 
        if (response.status == 200) {
            this.id=id;
        }  });
      },
    },
  };
  </script>